import { useNamespaceContainer } from "@pharaday/namespace";

import { UserRepository } from "../core/application/store/user.repository";

const useUserApi = () => {
  const container = useNamespaceContainer();

  return {
    api: {
      user: container.get<UserRepository>(UserRepository),
    },
  };
};

export { useUserApi };
